<!-- 生产工具小程序-设备激活注册 -->
<template>
  <div class="TAppletEARegister">
    <!-- <p class="rStatus">设备ID：{{$route.params.DeviceNoId}}，暂无此设备</p> -->
    <van-form input-align="right" @submit="register">
      <van-field
        v-model="deviceInfo.DeviceNoId"
        name="设备ID"
        label="设备ID"
        readonly
      />
      <van-field
        :class="['status', { 'offline': deviceInfo.Online === 'false'}]"
        v-model="deviceInfo.OnlineText"
        name="设备状态"
        label="设备状态"
        readonly
      />
      <van-field
        :class="[{'activation': deviceInfo.IsActivation === 1}]"
        v-model="deviceInfo.ActivationText"
        name="激活状态"
        label="激活状态"
        readonly
        v-if="deviceInfo.IsActivation === 1"
      />
      <van-field
        v-model="deviceInfo.CompanyName"
        name="设备所在公司"
        label="设备所在公司"
        readonly
      />
      <van-field
        v-model="deviceInfo.DeviceName"
        name="设备名称"
        label="设备名称"
        placeholder="请填写设备名称"
        :rules="[{ required: deviceInfo.IsActivation === 0, message: '请填写设备名称' }]"
        :readonly="deviceInfo.IsActivation === 1"
      />
      <van-field
        v-model="deviceInfo.pca"
        name="设备地址"
        label="设备地址"
        placeholder="请选择设备地址"
        :rules="[{ required: deviceInfo.IsActivation === 0, message: '请选择设备地址' }]"
        readonly
        right-icon="arrow"
        @click="showAreaPopup"
        v-if="deviceInfo.IsActivation === 0"
      />
      <van-field
        v-model="deviceInfo.address"
        name="详细地址"
        label="详细地址"
        placeholder="请填写详细地址"
        :rules="[{ required: deviceInfo.IsActivation === 0, message: '请填写详细地址' }]"
        :readonly="deviceInfo.IsActivation === 1"
        v-if="deviceInfo.IsActivation === 0"
      />
      <van-field
        v-model="deviceInfo.spaceName"
        name="空间分组"
        label="空间分组"
        placeholder="请选择空间分组"
        :rules="[{ required: deviceInfo.IsActivation === 0, message: '请选择空间分组' }]"
        readonly
        right-icon="arrow"
        @click="showSpacePopup"
        v-if="deviceInfo.IsActivation === 0"
      />
      <!-- <van-field
        v-model="deviceInfo.note"
        type="textarea"
        name="备注"
        label="备注"
        :placeholder="deviceInfo.IsActivation === 1 ? '/': '请填写备注'"
        :readonly="deviceInfo.IsActivation === 1"
      /> -->
      <div style="margin: 16px;" v-if="deviceInfo.IsActivation === 0">
        <van-button round block type="info" native-type="submit">激活</van-button>
      </div>
    </van-form>



    <!-- 省市区选择 -->
    <van-popup class="areaPopup" position="bottom" v-model="areaPopup">
      <!-- <van-area :area-list="areaList" /> -->
      <van-picker res="areaList" show-toolbar :columns="areaList" value-key="Name" :loading="areaLoading" @cancel="areaPopup = false" @confirm="getAreaValue"/>
    </van-popup>

    <!-- 选择空间分组 -->
    <keep-alive v-if="deviceInfo.IsActivation === 0">
      <multiSelector
        ref="multiSelector"
        :value.sync="deviceInfo.selectedSpaceId"
        :data="spaceList"
        :props="props"
        sText="请选择下级空间"
        groupTitle="空间分组"
        @confirm="getSpaceAddress"></multiSelector>
    </keep-alive>
    
    
    
  </div>
</template>

<script>
  import multiSelector from './module/multi-selector.vue'
  import { ToolAppletApi } from '../../../../static/js/phone/phoneApi.js'
  import { vshowLoading, vhideLoading, vshowSuccess, vshowToast } from '../../../../static/js/phone/utility.js'
  import { deepCopy, showToast } from '../../../../static/js/utility/utility'


  import Vue from 'vue'
  import {Form, Field, Button, Area, Popup, Cell, Picker} from 'vant'
  Vue.use(Form)
  Vue.use(Field)
  Vue.use(Button)
  Vue.use(Area)
  Vue.use(Popup)
  Vue.use(Cell)
  Vue.use(Picker)
  let vm

  export default {
    name: 'TAppletEARegister',
    components: {
      multiSelector
    },
    data () {
      return {
        // 设备详情
        deviceInfo: {},
        notePlaceholder: '',

        areaPopup: false,
        areaList: [],
        areaLoading: true,

        spaceList: [],
        props: {
          value: 'SpaceId',
          parent_value: 'ParentId',
          lable: 'SpaceName',
          children: 'Children'
        },
      }
    },
    created () {
      vm = this
      vm.GetDeviceInfo()    
    },
    mounted () {
    },
    methods: {
      /** 选择设备地址 */
      // 显示地址选择器
      showAreaPopup () {
        if (vm.deviceInfo.IsActivation === 1) { return }
        vm.areaPopup = true
      },
      // 获取省市区值
      getAreaValue (e) {
        // console.log('获取省市区值', e)
        vm.deviceInfo.areaArr = e
        vm.deviceInfo.pca = e[0]+e[1]+e[2]
        vm.areaPopup = false
      },

      /** 选择空间分组 */
      // 显示空间分组弹窗
      showSpacePopup() {
        if (vm.deviceInfo.IsActivation === 1) { return }
        vm.$refs.multiSelector.visible = true
      },
      // 获取空间分组名称
      getSpaceAddress (e) {
        vm.deviceInfo.spaceName = e.value.SpaceName
      },
      // 获取所有空间
      async GetSpaceByCompanyId () {
        let data = { CompanyId: vm.deviceInfo.CompanyId }
        let res = await ToolAppletApi.GetSpaceByCompanyId(data)
        // console.log('res', res)
        if (res.ErrCode === 0) {
          vm.spaceList = [...res.Result]
        } else {
          showToast(res.ErrMsg)
        }
      },


      // 获取省市区id
      getAreaIdArr () {
        let allAreaList = vm.allAreaList
        let areaArr = vm.deviceInfo.areaArr
        let province, city, area
          allAreaList.forEach((item, i)=>{
            if (item.Name === areaArr[0] && item.Type === 1) {
              province = item.Id
            }
            if (item.Name === areaArr[1] && item.Type === 2) {
              city = item.Id
            }
            if (item.Name === areaArr[2] && item.Type === 3) {
              area = item.Id
            }
          })
        return { province, city, area }
      },
      // 设备注册
      async register () {
        console.log('deviceInfo.selectedSpaceId', vm.deviceInfo.selectedSpaceId)
        let data = vm.getAreaIdArr() // 获取省市区id
        data.deviceId = vm.deviceInfo.DeviceNoId   // 设备id
        data.companyId = vm.deviceInfo.CompanyId   // 公司id
        data.spaceId = vm.deviceInfo.selectedSpaceId  // 空间分组id
        data.country = 1
        data.address = vm.deviceInfo.address   // 详细地址
        data.alias = vm.deviceInfo.DeviceName  // 设备名称
        data.note = ''         // 备注
        
        console.log('data', data)
        vshowLoading('正在激活')
        let res = await ToolAppletApi.RegisterDevice(data)
        vhideLoading()
        if (res.meta.code === 200) {
          vshowSuccess('激活成功')
          setTimeout(() => {
            vm.GetDeviceInfo()
          }, 1000)
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取设备信息
      async GetDeviceInfo () {
        let data = {
          DeviceNoId: vm.$route.params.DeviceNoId
        }

        vshowLoading('获取设备信息中')
        let res = await ToolAppletApi.GetDeviceInfo(data)
        vhideLoading()
        if (res.DeviceNoId) {
          let deviceInfo = res
          deviceInfo.OnlineText = res.Online === 'true' ? '在线' : '离线'
          deviceInfo.ActivationText = res.IsActivation === 1 ? '已激活' : '未激活'
          vm.notePlaceholder = deviceInfo.IsActivation === 1 ? '/': '请填写备注'
          vm.deviceInfo = deviceInfo
          if (deviceInfo.IsActivation === 1) {
            vm.GetSpaceByCompanyId()
            vm.GetAreaStree()
          }
        } else {
          vshowToast('获取设备信息失败')
        }
        // console.log('data', res)
      },
      // 获取所有子级地址
      async GetAreaStree () {
        let res = await ToolAppletApi.GetAreaStree()
        if (res.ErrCode === 0) {
          vm.areaList = vm.processAreaList(res.Result[0].Children)
          vm.areaLoading = false
        } else {
          vshowToast(res.ErrMsg)
        }
      },
      // 处理数据
      processAreaList (data) {
        data.forEach((item, i)=>{
          let newItem = item
          newItem.children = item.Children
          delete newItem['Children']
          data[i] = newItem
          data[i].children.forEach((jtem, j)=>{
            let newJtem = data[i].children[j]
            newJtem.children = jtem.Children
            delete newJtem['Children']
            data[i].children[j] = newJtem
          })
        })
        return data
      },
      // 获取父地址id数组
      getPidArr() {
        let pidArr = []
        let list = vm.allAreaList
        for (let i = 0; i < list.length; i++) {
          let item = list[i]
          if (pidArr.indexOf(item.ParentId) === -1) {
            if (item.ParentId != undefined) {
              pidArr.unshift(item.ParentId)
            }
          }
        }
        return pidArr
      },
      //  根据allSenceList获取空间列表
      toGetList() {
        let temArr = this.getPidArr()
        let allList = deepCopy(vm.allAreaList)
        let newList = []
        // console.log('temArr', temArr)

        //获取新地址列表 （部门不超过五级）
        let rev = (num) => {
          // console.log('num____________', num)
          let afterInfo = {}, children = []
          for (let i = 0; i < [...allList].length; i++) {
            let item = allList[i]
            let p_id = temArr[num]
            if (item.Id === p_id) {
              afterInfo = item
            } else if (item.ParentId === p_id) {
              children.push(item)
            }
          }

          // 将新增的地址信息添加到同级地址的下方
          if (afterInfo.children) {
            afterInfo.children[0].Id = afterInfo.children[0].ParentId + (children.length + 1)
            children.push(afterInfo.children[0])
          }
          afterInfo.children = children

          if (num + 1 < temArr.length) {
            rev(num + 1)
          } else {
            newList = [afterInfo]
          }
        }
        rev(0)
        // console.log('newList', newList)
        return newList[0].children[0].children
      },
    }
  }
</script>

<style lang="scss">
.TAppletEARegister {
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  background-color: #f0f0f0;
  .areaPopup {
    width: 100vw;
  }
  .rStatus {
    padding: 10px 16px;
    font-size: 0.28rem;
    // color: #E6A23C;
  }
  .van-field__control {
    color: #666;
  }
  .activation .van-field__control,
  .status .van-field__control{
    color: #67C23A;
  }
  .status.offline .van-field__control {
    color: #F56C6C;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/PhonePage/ToolApplet/EARegister.vue